export const IDIOMAS = [
    { code: 'es'}, 
    { code: 'en'}, 
]